import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import NumberFormat from 'react-number-format';

import { numberFormat } from 'constants/formats';
import { Range } from 'types';

import InputError from 'modules/_shared/components/InputError';
import LoadingButton from 'modules/_shared/components/LoadingButton';
import SharesRangeRow from './ShareRangesRow';

type ShareRangesProps = {
  sharesRanges: Range[];
  shareFrom: number;
  shareTo: number;
  isValidRange: boolean;
  isValidatingRange: boolean;
  additionalConditions?: boolean;
  isTransferingAllShares?: boolean;
  handleChangeShareFrom: (event: React.ChangeEvent<HTMLInputElement>) => void; // eslint-disable-line
  handleChangeShareTo: (event: React.ChangeEvent<HTMLInputElement>) => void; // eslint-disable-line
  handleValidateRange: () => void;
};
const ShareRanges: FC<ShareRangesProps> = ({
  sharesRanges,
  shareFrom,
  shareTo,
  isValidRange,
  isValidatingRange,
  additionalConditions,
  isTransferingAllShares = false,
  handleChangeShareFrom,
  handleChangeShareTo,
  handleValidateRange,
}) => {
  const { t } = useTranslate();

  const validateRangeButtonDisabled =
    !shareFrom || !shareTo || shareFrom > shareTo || additionalConditions;

  return (
    <>
      {sharesRanges.map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="form-control-wrap pb-1" key={`row-${index}`}>
          <SharesRangeRow index={index} sharesRanges={sharesRanges} />
        </div>
      ))}

      <div className="input-group">
        <div className="input-group-prepend">
          <span className="input-group-text" id="share-from">
            {t('OfTheNo')}
          </span>
        </div>
        <NumberFormat
          id="share-from"
          className="form-control form-control-outlined"
          value={shareFrom}
          onChange={handleChangeShareFrom}
          thousandSeparator={numberFormat.thousandSeparator}
          decimalSeparator={numberFormat.decimalSeparator}
          allowNegative={false}
          disabled={isTransferingAllShares}
          decimalScale={0}
        />

        <div className="input-group-prepend">
          <span className="input-group-text" id="share-to">
            {t('ToTheNo')}
          </span>
        </div>
        <NumberFormat
          id="share-to"
          className="form-control form-control-outlined "
          value={shareTo}
          onChange={handleChangeShareTo}
          thousandSeparator={numberFormat.thousandSeparator}
          decimalSeparator={numberFormat.decimalSeparator}
          allowNegative={false}
          disabled={isTransferingAllShares}
          decimalScale={0}
        />

        <LoadingButton
          isLoading={isValidatingRange}
          onClick={handleValidateRange}
          text={t('ValidateRange')}
          icon="ni-check"
          className="btn btn-outline-primary btn-dim border-radius-0"
          disabled={validateRangeButtonDisabled}
        />
      </div>

      {!isValidRange && (
        <div className="mt-1">
          <InputError errorMessage="InvalidRange" />
        </div>
      )}
    </>
  );
};

export default ShareRanges;
